import { createTheme } from '@mui/material/styles'

export const yellow = '#f9d31b'
export const lightYellow = '#fff9da'
export const lightGreen = '#f2f0e5'

export const theme = createTheme({
  palette: {
    primary: {
      main: '#165530',
    },
    secondary: {
      main: lightGreen,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: 'none',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {

      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: 'none',
        },
      }
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderRadius: 8,
              backgroundColor: 'rgba(255, 255, 255, 0.23)',
            }
          }
        },
      },
    }
  },
})
